import { Injectable, Inject, EventEmitter, Output } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment, AuthenSecretKey } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  @Output() login_success = new EventEmitter<boolean>();

  tokenurl: string;
  tokenAuthUrl: string;
  tokenAuthEmpServiceUrl: string;
  oauthUrl: string;
  refreshToken: string;
  private isRedirecting: boolean = false; // Flag to prevent multiple redirects

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router) {
    this.oauthUrl = environment.base_api;
    this.tokenurl = environment.token_api;
    this.tokenAuthUrl = environment.token_auth_api;
    this.tokenAuthEmpServiceUrl = environment.token_auth_api_empservice;
  }

  GetAccessTokenUrl(empcode: string = "") {
    let url = "https://login.microsoftonline.com/" + AuthenSecretKey.keytenantId
      + "/oauth2/v2.0/authorize?client_id=" + AuthenSecretKey.keyclient_id
      + "&response_type=" + AuthenSecretKey.response_type
      + "&scope=" + AuthenSecretKey.scope;
    if (!!empcode) {
      url += "&state=" + empcode
    }
    url += "&redirect_uri=" + environment.base_api + AuthenSecretKey.keyredirect_uri;
        
    return url;
  }

  async GetToken(Email: string, Password: string, AppId: string): Promise<any>{
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    let objData = {};
    objData["Email"] = Email;
    objData["Password"] = Password;
    objData["AppId"] = AppId;

    let strjson = JSON.stringify(objData);

    return this.httpClient
      .post<any>((AppId != "POP") ? this.tokenAuthEmpServiceUrl :this.tokenAuthUrl, strjson, httpOptions)
      .toPromise();
  }

  async RefreshToken(): Promise<string | null> {
    // Prevent multiple calls if already redirecting
    if (this.isRedirecting) {
      return null;
    }

    try {
      const res = await this.GetRefreshToken();
      
      // Check if response has error or token is invalid
      if (!res || res.isError || !res.data || !res.data.refreshToken) {
        console.log('Refresh token expired or invalid, redirecting to app component');
        this.handleTokenExpiry();
        return null;
      }
      
      return res.data.refreshToken;
    } catch (error) {
      console.error('Token refresh failed:', error);
      
      // Check if it's 401 Unauthorized (token expired)
      if (error.status === 401 || error.status === 403) {
        console.log('Token expired (401/403), redirecting to app component');
        this.handleTokenExpiry();
        return null;
      }
      
      // For other errors, still redirect to be safe
      this.handleTokenExpiry();
      return null;
    }
  }

  async GetRefreshToken(): Promise<any> {
    var auth_token = localStorage.getItem("refreshToken");
    var email = localStorage.getItem("email");

    // Check if tokens exist in localStorage
    if (!auth_token || !email) {
      console.log('No tokens found in localStorage');
      this.handleTokenExpiry();
      return { isError: true, message: 'No tokens found' };
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let objData = {};
    objData["Email"] = email;
    objData["RefreshToken"] = auth_token;
        
    let strjson = JSON.stringify(objData);
        
    return this.httpClient
      .post<any>(this.tokenurl + 'api/RefreshToken', strjson, httpOptions)
      .toPromise();
  }

  // Handle token expiry - clear storage and redirect
  private handleTokenExpiry() {
    // Prevent multiple redirects
    if (this.isRedirecting) {
      return;
    }
    
    this.isRedirecting = true;
    
    // Clear all tokens from localStorage
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("email");
    localStorage.removeItem("accessToken"); // ถ้ามี
    
    // Use setTimeout to ensure redirect happens after current call stack
    setTimeout(() => {
      this.RedirectToAppComponent();
    }, 100);
  }

  // Redirect to app component instead of login
  RedirectToAppComponent() {
    console.log('Redirecting to app component due to token expiry');
    alert("Your session expire will need to re-login");
    
    // Force navigation and reload
    localStorage.clear();
    this.router.navigate(['/']);
    window.location.href = '/';
    this.login_success.emit(false)
  }

  // Keep the original method for other use cases
  RedirectToLogin() {
    this.router.navigate(["/"]);
  }

  // Helper method to check if user is authenticated
  isAuthenticated(): boolean {
    const refreshToken = localStorage.getItem("refreshToken");
    const email = localStorage.getItem("email");
    return !!(refreshToken && email) && !this.isRedirecting;
  }

  // Method to reset redirect flag (call this when user logs in successfully)
  resetRedirectFlag() {
    this.isRedirecting = false;
  }
}